<div class="container-fluid">
  <div class="row">
    <div class="pnl-header col-12">
      <app-header></app-header>
    </div>
    <div class="pnl-content col-12">
      <app-wizard></app-wizard>
    </div>
    <div class="pnl-footer col-12">
      <app-form-footer></app-form-footer>
    </div>
  </div>
</div>